var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.25 7.21106V16.7501L49.3154 16.7501C53.101 16.7501 56.4009 19.3266 57.319 22.9992L58.6445 28.3012C59.1221 30.2117 58.9006 32.2301 58.0198 33.9916L48.6708 52.6896C47.2733 55.4846 44.4167 57.2501 41.2918 57.2501L26.0912 57.2501C24.8768 57.2501 23.6773 56.982 22.5784 56.4649L13.2543 52.0771C12.3004 53.3937 10.7502 54.2501 9 54.2501H6C3.10051 54.2501 0.75 51.8996 0.75 49.0001V25.0001C0.75 22.1007 3.10051 19.7501 6 19.7501H9C10.4034 19.7501 11.6783 20.3008 12.6202 21.1979L15.9889 17.8293C16.1669 17.6513 16.306 17.4787 16.4169 17.3033C17.4167 15.7224 20.322 10.8729 21.3777 6.62902C21.6477 5.54335 22.0797 4.25189 22.8275 3.13433C23.5974 1.98374 24.7936 0.895317 26.5486 0.576302C28.0042 0.311708 29.3496 0.407263 30.4723 0.63534C33.9199 1.33569 35.25 4.64944 35.25 7.21106Z",
    fill: "var(--ncap-300)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpIcon);
export default __webpack_public_path__ + "static/media/thumb-up-icon.cc54415f3d48b54dc1b5896d00cd3e6a.svg";
export { ForwardRef as ReactComponent };